import React, { useState } from "react";
import { Grid, TextField, Checkbox, FormControlLabel, Box, Typography, Divider, Container } from "@mui/material";
import { date_availability_fields, discountGroupObjects } from "../data";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function ApplicableDate({ value, setValue, disable }) {
	// State variables
	const [days, setDays] = useState({});

	return (
		<Box pl={2} display={"flex"} flexDirection={"row"} width={"100%"}>
			<Box display="flex" columnGap={2} flexDirection={"column"} rowGap="10px" flexWrap="wrap" width={"55%"}>
				{date_availability_fields?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="100%"
							selectOptObjName={"option_data"}
							key={row.key}
							disabled={disable}
							minDateTime={value[discountGroupObjects.applicable_date.key].start_date}
						/>
					);
				})}
			</Box>
			{/* Applicable Days */}
			<Grid item xs={12} pl={10}>
				<Typography variant="body1" pb={1} pt={0}>
					Applicable Days
				</Typography>
				<Grid container spacing={0} display={"flex"} flexDirection={"column"}>
					{["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day, index) => (
						<Grid item xs={3} key={day}>
							<FormControlLabel
								control={
									<Checkbox
										checked={value.applicable_date.applicable_days.includes(day)}
										disabled={disable}
										onChange={() => {
											const currentDays = value.applicable_date.applicable_days;
											const updatedDays = currentDays.includes(day)
												? currentDays.filter((d) => d !== day)
												: [...currentDays, day];

											setValue((prev) => ({
												...prev,
												applicable_date: {
													...prev.applicable_date,
													applicable_days: updatedDays,
												},
											}));
										}}
									/>
								}
								label={day}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Box>
	);
}

export default ApplicableDate;
